/* app/js/src/components/clean-scheduler/clean-scheduler.scss */
.cursor-pointer {
  cursor: pointer;
}
input[type=text],
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
input[type=text]::-webkit-input-placeholder,
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]::-moz-placeholder,
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input.ng-invalid.ng-dirty[type=text],
input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-export {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-export:focus {
  outline-color: #ffffff;
}
.btn-export:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-export {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  margin-bottom: 10px;
}
.input-group label {
  display: inline-block;
  margin-right: 13px;
  color: #7d8fa1;
}
.input-group input[type=text] {
  width: 305px;
  border-radius: 4px;
  vertical-align: middle;
}
.input-group:not(:last-child) {
  margin-bottom: 30px;
}
.input-group > * {
  vertical-align: middle;
}
.tasks .task {
  font-style: italic;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-size: 12px;
}
.tasks .task-content {
  font-style: normal;
  margin-top: 14px;
}
:host {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  overflow: hidden;
}
.export-epg-screen-container {
  background-color: #f1f3f4;
  height: 100%;
}
.export-epg-screen {
  height: 100%;
  padding-left: 205px;
  padding-top: 81px;
}
h1 {
  margin: 0;
  color: #232f3a;
  font-family: TitilliumWeb;
  font-size: 36px;
  font-weight: bold;
}
h2 {
  margin: 0;
  margin-top: 24px;
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 13px;
}
.date-picker-epg-container,
.media-duration-container,
.choose-add-platform-container {
  margin-top: 28px;
}
.date-picker-epg-content {
  display: inline;
  padding-left: 15px;
}
.media-duration-content {
  display: inline;
  padding-left: 32px;
}
.choose-add-platform-content {
  display: inline;
  padding-left: 10px;
}
.epg-option-inline {
  font-family: "Open Sans";
  font-size: 12px;
  color: #232f3a;
}
.epg-option {
  font-family: OpenSans;
  font-size: 12px;
  color: #7d8fa1;
}
dateinput {
  position: relative;
  display: inline-block;
  margin-left: 10px;
  margin-right: 15px;
  width: 170px;
}
input[type=text] {
  width: 80px;
  height: 26px;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 7px;
  margin-right: 7px;
}
.btn-export {
  position: absolute;
  margin-top: 30px;
  left: 716px;
}
icn-dropdown {
  margin-left: 15px;
  margin-right: 15px;
  width: 411px;
  height: 28px;
}
.svg-icon-export {
  margin-left: 15px;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  width: 30px;
  vertical-align: middle;
}
.export-platforms-dropdown {
  width: 341px;
}
.platforms-export-container {
  margin-top: 28px;
}
icn-export-platforms {
  position: absolute;
  top: -150px;
}
/*# sourceMappingURL=clean-scheduler.css.map */
